import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

interface PageLoaderProps {
  message?: string;
  submessage?: string;
  icon?: React.ReactNode;
}

/**
 * Full-page loader with spinner and message
 * 
 * Use this component ONLY for:
 * - Initial app/route loading
 * - Full-page transitions
 * - Critical blocking operations
 * 
 * For better UX, prefer using inline Skeleton components from Skeleton.tsx
 * which provide content-aware loading placeholders without blocking the UI.
 * 
 * @param message - Main loading message (e.g., "Loading...")
 * @param submessage - Optional secondary message
 * @param icon - Optional icon to display with the spinner
 */
const PageLoader: React.FC<PageLoaderProps> = ({
  message = "Loading...",
  submessage,
  icon,
}) => {
  return (
    <div className="page-loader-container">
      <div className="page-loader-card">
        <div className="page-loader-content">
          <div className="page-loader-spinner">
            {icon || <CircularProgress size={48} thickness={4} />}
          </div>
          <div className="page-loader-text">
            <p className="page-loader-message">{message}</p>
            {submessage && <p className="page-loader-submessage">{submessage}</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageLoader;
